'use client'

import type { GetCollectionStructureOutputDTO } from '@algoacademy/backend/modules/docs/endpoints/queries/get-collection-structure/output.dto'
import { createContext, useContext } from 'react'

type CollectionStructureContextValue = GetCollectionStructureOutputDTO

const CollectionStructureContext = createContext<CollectionStructureContextValue | null>(null)

export function CollectionStructureProvider({
  data,
  children
}: {
  data: GetCollectionStructureOutputDTO
  children: React.ReactNode
}) {
  return (
    <CollectionStructureContext.Provider value={data}>
      {children}
    </CollectionStructureContext.Provider>
  )
}

export function useCollectionStructure() {
  const ctx = useContext(CollectionStructureContext)
  if (!ctx) {
    throw new Error('useCollectionStructure must be inside CollectionStructureProvider')
  }
  return ctx
}
